import { computed } from 'vue';

import { useRoutingApplication } from './routing-application.composable';
import { LOCAL_DOMAINS } from '../models/constants';

const useDebugger = () => {
  const { queryParams } = useRoutingApplication();

  const isDebugMode = computed(
    () => LOCAL_DOMAINS.find((domain) => window.location.hostname === domain) && queryParams?.value.debug,
  );

  return {
    isDebugMode,
  };
};

export { useDebugger };
